import Faq from "@components/pages/faq";
import SEOHEAD from "@components/SEOHEAD";
import FloatScrollButton from "@components/ui/FloatScrollButton";
import NewCourses from "@components/ui/landing/NewCourses";
import gate from "gate";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import React, { FC, useState } from "react";
import { dehydrate, QueryClient, useQuery } from "react-query";

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  const queryClient = new QueryClient();
  let isError = false;

  try {
    await queryClient.fetchQuery(["getRecommendedEntityMain"], () =>
      gate.getRecommendedEntityMain()
    );
  } catch (error: any) {
    isError = true;
    ctx.res.statusCode = error?.response?.status;
    console.log("---------------->", error);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
};
type Props = {
  isError: boolean;
};
const Index: FC<Props> = ({ isError }) => {
  const { data, status } = useQuery(
    ["getRecommendedEntityMain"],
    () => gate.getRecommendedEntityMain(),
    {
      select: (data: any) => data?.data?.output,
    }
  );

  return (
    <>
      <SEOHEAD
        {...{
          canonical: `https://dadbanan.com/faq`,
          title: "سوالات متداول | مؤسسه دادبانان",
          keyword: ["تماس با ما"],
          seoDescription:
            "جهت تماس با ما(مؤسسه حقوقی دادبانان) با شماره‌های زیر تماس حاصل فرمایید:  واحد آموزش و ثبت نام: ۵۵۵۰ ۵۸ ۲۲ – ۰۲۱ واحد انتشارات و سفارش کتاب: ۴۹۰۰ ۵۸ ۲۲ – ۰۲۱،   رزرو و مشاوره حضوری: ۰۱۳۷ ۵۸ ۲۲ – ۰۲۱",
        }}
      />
      <div className="bg-[#FAFAFC] py-6 px-[4%] md:py-10 lg:px-[10%] xl:py-[60px]">
        <Faq />
        <div className="mt-[60px] w-full">
          <NewCourses
            title="دوره ها و بسته های پیشنهادی"
            data={data}
            breakpoints={{
              300: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              375: {
                slidesPerView: 1.1,
                spaceBetween: 5,
              },
              767: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 24,
              },
            }}
          />
        </div>
      </div>
      <FloatScrollButton />
    </>
  );
};

export default Index;
